/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_Save_Context_Unavailable_ToastInputs */

const en_explorer_search_save_context_unavailable_toast = /** @type {(inputs: Explorer_Search_Save_Context_Unavailable_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening search results is not available while overwriting. Open the folder first.`)
};

const fr_explorer_search_save_context_unavailable_toast = /** @type {(inputs: Explorer_Search_Save_Context_Unavailable_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening search results is not available while overwriting. Open the folder first.`)
};

const de_explorer_search_save_context_unavailable_toast = /** @type {(inputs: Explorer_Search_Save_Context_Unavailable_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening search results is not available while overwriting. Open the folder first.`)
};

const it_explorer_search_save_context_unavailable_toast = /** @type {(inputs: Explorer_Search_Save_Context_Unavailable_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening search results is not available while overwriting. Open the folder first.`)
};

const ru_explorer_search_save_context_unavailable_toast = /** @type {(inputs: Explorer_Search_Save_Context_Unavailable_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening search results is not available while overwriting. Open the folder first.`)
};

const es_explorer_search_save_context_unavailable_toast = /** @type {(inputs: Explorer_Search_Save_Context_Unavailable_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening search results is not available while overwriting. Open the folder first.`)
};

const zh_cn2_explorer_search_save_context_unavailable_toast = /** @type {(inputs: Explorer_Search_Save_Context_Unavailable_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening search results is not available while overwriting. Open the folder first.`)
};

const ja_explorer_search_save_context_unavailable_toast = /** @type {(inputs: Explorer_Search_Save_Context_Unavailable_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening search results is not available while overwriting. Open the folder first.`)
};

const hi_explorer_search_save_context_unavailable_toast = /** @type {(inputs: Explorer_Search_Save_Context_Unavailable_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening search results is not available while overwriting. Open the folder first.`)
};

const pt_pt2_explorer_search_save_context_unavailable_toast = /** @type {(inputs: Explorer_Search_Save_Context_Unavailable_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening search results is not available while overwriting. Open the folder first.`)
};

/**
* | output |
* | --- |
* | "Opening search results is not available while overwriting. Open the folder first." |
*
* @param {Explorer_Search_Save_Context_Unavailable_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_save_context_unavailable_toast = /** @type {((inputs?: Explorer_Search_Save_Context_Unavailable_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_Save_Context_Unavailable_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_search_save_context_unavailable_toast(inputs)
	if (locale === "de") return de_explorer_search_save_context_unavailable_toast(inputs)
	if (locale === "it") return it_explorer_search_save_context_unavailable_toast(inputs)
	if (locale === "ru") return ru_explorer_search_save_context_unavailable_toast(inputs)
	if (locale === "es") return es_explorer_search_save_context_unavailable_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_search_save_context_unavailable_toast(inputs)
	if (locale === "ja") return ja_explorer_search_save_context_unavailable_toast(inputs)
	if (locale === "hi") return hi_explorer_search_save_context_unavailable_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_search_save_context_unavailable_toast(inputs)
	return en_explorer_search_save_context_unavailable_toast(inputs)
});